import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import NumberFieldInnerTable from '../../inputs/NumberFieldInnerTable'

const LifeInsurance = ({ data, setData }) => {
  const { t } = useLocalize()
  React.useEffect(() => {
    if (
      data.isLifeInsuranceEnabled === false &&
      ('lifeInsuranceValue' in data || 'lifeInsuranceValueWorker' in data)
    ) {
      const { lifeInsuranceValue, lifeInsuranceValueWorker, ...rest } = data
      setData(rest)
    }
  }, [data])
  return (
    <div className="tw-flex tw-flex-col tw-gap-3 tw-px-5 tw-pt-3">
      <div className="tw-flex tw-flex-col tw-gap-1">
        <label className="tw-text-xs tw-text-content-subtle">
          {t('contract.employer-contribution')}
        </label>
        <NumberFieldInnerTable
          innerLabel="PLN"
          placeholder="0,00"
          value={data?.lifeInsuranceValue?.toString() || ''}
          onChange={(e) => {
            setData({
              ...data,
              lifeInsuranceValue: Number(e.target.value),
            })
          }}
        />
      </div>
      <div className="tw-flex tw-flex-col tw-gap-1">
        <label className="tw-text-xs tw-text-content-subtle">
          {t('contract.employee-contribution')}
        </label>
        <NumberFieldInnerTable
          innerLabel="PLN"
          placeholder="0,00"
          value={data?.lifeInsuranceValueWorker?.toString() || ''}
          onChange={(e) => {
            setData({
              ...data,
              lifeInsuranceValueWorker: Number(e.target.value),
            })
          }}
        />
      </div>
    </div>
  )
}

export default LifeInsurance
